var map = {
	"./assay.js": 1093,
	"./bioproject.js": 593,
	"./biosample.js": 1094,
	"./diet.js": 1095,
	"./file.js": 1096,
	"./lab.js": 594,
	"./litter.js": 1097,
	"./mouse.js": 1098,
	"./reagent.js": 1099,
	"./treatment.js": 1100
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 592;


//////////////////
// WEBPACK FOOTER
// ./src/json/fields ^\.\/.*\.js$
// module id = 592
// module chunks = 0